import { ReviewStatus } from "types/reviews";

export const defaultValues = {
  rate: 0,
  review: "",
  status: ReviewStatus.REVIEW,
  reason: "",
};
